import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAll } from "./apiLogAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchAll = createAsyncThunk(
  "apiLog/fetchAll",
  async (payload) => {
    const response = await getAll(payload);
    return response.data;
  }
);



export const apiLogSlice = createSlice({
  name: "apiLog",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      
  },
});

export const { resetData, setSelected } = apiLogSlice.actions;

export const selectData = (state) => state.apiLog.data;
export const selectLoading = (state) => state.apiLog.loading;
export const selectError = (state) => state.apiLog.error;
export const selectPageNo = (state) => state.apiLog.pageNo;
export const selectPageSize = (state) => state.apiLog.pageSize;
export const selectTotalRecord = (state) => state.apiLog.totalRecord;
export const selectSelected = (state) => state.apiLog.selected;
export const selectResult = (state) => state.apiLog.result;

export default apiLogSlice.reducer;
